const EmailInput = (props) => (
    <input 
    type="email" 
    placeholder="example@email.com"
    onChange={e => props.change(e.target.value)}
    className={"border-2 border-black rounded-md p-2 placeholder:text-zinc-500 " + props.className}/>
)

export default EmailInput